
import React from "react";
import { Link } from "react-router-dom";

export default class CommunicationPanel extends React.Component {
    render() {
        return (
          <div>
                <div id="circular-menu" className="circular-menu">
                    <a className="floating-btn" >
                        <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                        <i aria-hidden="true" className="fa fa-times"></i>
                    </a>
                    <div className="items-wrapper">
                        <div className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </div>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </a>
                        <Link to="" className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </Link>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        </a>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="form-head d-flex flex-wrap align-items-center">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Corporate Communication</h2>
                                <p className="text-light">Lorem ipsum dolor sit amet</p>
                            </div>
                        </div>
                        <div className="col-xl-9">
                            <div className="card">
                                <div className="card-body">
                                    <div className="">
                                        <label className="text-primary mb-2 sumh04">Notification Title*</label>
                                        <div className="form-group d-flex mb-4">
                                            <input type="text" name="" className="form-control" placeholder="Reminder Title goes here" />
                                        </div>
                                        <label className="text-primary mb-2 sumh04">Select User/Groups*</label>
                                        <div className="form-group d-flex mb-4">
                                            <select className="form-control mr-4">
                                                <option selected disabled>Select User</option>
                                                <option>Aman verma</option>
                                                <option>Kajal jain</option>
                                                <option>Savita rana</option>
                                            </select>
                                            <select className="form-control">
                                                <option selected disabled>Select Group</option>
                                                <option>Group 01</option>
                                                <option>Group 02</option>
                                                <option>Group 03</option>
                                            </select>
                                        </div>
                                        <label className="text-primary mb-2 sumh04">Notification Message</label>
                                        <div className="form-group d-flex mb-4">
                                            <textarea className="form-control" rows="5" cols="1"></textarea>
                                        </div>
                                        <label className="text-primary mb-2 sumh04">Notification Image</label>
                                        <div className="form-group d-flex mb-4">
                                            <input type="file" name="" className="form-control" />
                                        </div>
                                        <div className="form-group check-use mb-4 d-flex">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="gridRadios" value="option2" />
                                                <label className="form-check-label">
                                                    Link to campaign
                                                </label>
                                            </div>
                                        </div>
                                        <button className="add-btncss d-block w-auto">Send</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3">
                            <div className="row sidecarddd">
                                <div className="col-xl-12">
                                    <div className="leave-ad-design card is-birthday-card" data-background="assets/img/illustrations/cards/birthday-bg.svg">
                                        <div className="card-body">
                                            <div>
                                                <div className="birthday-avatar text-center">
                                                   <svg viewBox="0 0 160 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="160" height="90">
  <rect x="20" y="40" width="30" height="44" rx="4" fill="#671cc9" opacity=".85"></rect>
  <rect x="22" y="42" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="22" y="47" width="20" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="52" y="30" width="30" height="54" rx="4" fill="#ec4119" opacity=".85"></rect>
  <rect x="54" y="32" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="54" y="37" width="18" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="84" y="20" width="30" height="64" rx="4" fill="#26a69a" opacity=".85"></rect>
  <rect x="86" y="22" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="86" y="27" width="22" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <circle cx="132" cy="42" r="12" fill="#f7c5a8"></circle>
  <path d="M126 38 Q128 32 132 32 Q136 32 138 38" fill="#2d1a0e"></path>
  <circle cx="129" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <circle cx="135" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <path d="M129 47 Q132 50 135 47" stroke="#2d1a0e" stroke-width="1" stroke-linecap="round" fill="none"></path>

  <rect x="122" y="54" width="20" height="24" rx="8" fill="#671cc9"></rect>
  <path d="M122 78 Q114 82 108 78" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>
  <path d="M142 78 Q150 82 152 76" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>

  <rect x="108" y="62" width="18" height="13" rx="3" fill="#ec4119" opacity=".9"></rect>
  <rect x="110" y="64" width="14" height="1.5" rx=".75" fill="#fff" opacity=".6"></rect>
  <rect x="110" y="68" width="10" height="1.5" rx=".75" fill="#fff" opacity=".4"></rect>

  <text x="96" y="18" font-size="10" fill="#ec4119" opacity=".8">✦</text>
  <text x="148" y="28" font-size="8" fill="#671cc9" opacity=".7">✦</text>
  <text x="12" y="36" font-size="7" fill="#26a69a" opacity=".7">✦</text>
</svg>
                                                </div>
                                                <div className="birthday-content">
                                                    <h4 className="mb-3">Review our employee leave policy</h4>
                                                    <Link to="Policylist" type="button" className="button light-button">View</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="contact-manager">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>
                            </div>
                            <div className="modal-body text-center">
                                <form>
                                    <div className="form-group text-left">
                                        <label>Repoting Manager</label>
                                        <select className="default-select form-control wide mb-3">
                                            <option selected disabled>Select reporting manager</option>
                                            <option>Arun Mishra</option>
                                            <option>Pragya Tiwari</option>
                                            <option>Alisha Goyal</option>
                                        </select></div>
                                    <div className="form-group text-left">
                                        <label className="mt-3">Reason</label>
                                        <textarea rows="4" cols="1" className="form-control"></textarea></div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                                <button type="button" className="btn btn-primary">Accept</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}